module.exports = __webpack_public_path__ + "img/event_hoodie.bb6cf387.svg";